import axios from "axios"
import ids_langs from 'data/filo-tag-ids-langs.json'

const MAIN_DOMAIN = 'https://filotrack.com'

export async function addItem(productId, quantity){

    let LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
    let PATH_LANG = LANG === "en" ? "" : `/${LANG}`
    let url = `${MAIN_DOMAIN}${PATH_LANG}/checkout/?add-to-cart=${productId}&quantity=${quantity}`


    const response = await axios.get(url)

    const result = await response.data

    // console.log("add-item", result)

    const RESULT_SPLIT = result.split("_wpnonce=")
    const SPLIT2 = RESULT_SPLIT[1].split('"')
    const WP_NONCE = SPLIT2[0]

    let existing_wp_nonce = localStorage.getItem("wp_nonce")
    if(existing_wp_nonce === null || existing_wp_nonce === undefined || existing_wp_nonce === "") {
        localStorage.setItem("wp_nonce", WP_NONCE)
    }

    return result


}

export async function updateCart(){
    const LANG = document.documentElement.lang.substring(0, 2)

    const DOMAIN_URL = `${MAIN_DOMAIN}/${LANG === "en" ? "" : `/${LANG}`}`

    const TEST_URL = `${DOMAIN_URL}/checkout`

    const wcCart = await getCart()

    if(wcCart !== undefined && wcCart !== null && wcCart.items.length > 0){

        // console.log("update wc_cart", wcCart)

        const existing_cart = localStorage.getItem("existing_cart")

        if(existing_cart !== undefined && existing_cart !== null && existing_cart !== ""){

            const existing_cart_obj = JSON.parse(existing_cart)


            await Promise.all(
                wcCart.items.map( async item => {

                    
                    const foundInExistingCart = Object.values(existing_cart_obj).find(inCart => {
                        let default_id = inCart.id
                        if(LANG !== "en"){
                            default_id = ids_langs.find( variation => variation.includes(inCart.id))[0]
                        }
                        
                        return default_id === item.id.toString()
                    })
                    console.log("foundInExistingCart",foundInExistingCart)

                    if(foundInExistingCart !== undefined && foundInExistingCart !== null){

                        const new_quantity = parseInt(foundInExistingCart.quantity)

                        console.log("new_quantity", new_quantity)
                        console.log("in_cart_quantity", item.quantity.value)

                        if(new_quantity !== parseInt(item.quantity.value)){

                            // const update_item = await axios.post(
                            //     `https://filotrack.com/wp-json/cocart/v2/cart/item/${item.item_key}`,
                            //     {
                            //         quantity: `${new_quantity}`
                            //     },
                            //     {
                            //         headers: new Headers({ "Content-Type": "application/json"})
                            //     }
                            // )
    
                            // console.log("update_item", update_item)

                            // return update_item

                            return {
                                wc_cart_item_id: item.id,
                                wc_cart_item_key: item.item_key,
                                local_item_id: foundInExistingCart.id,
                                new_quantity
                            }

                        } else {
                            return false
                        }

                    } else {
                        await removeWcProduct(item.id)
                        return false
                    }

                })
            )
            .then(async (result) => {
                const all_items_changed = result.filter( item => item !== false );
                if(all_items_changed.length === 0) return []

                return await Promise.all(
                    all_items_changed.map( async item => {

                        await removeWcProduct(item.local_item_id)

                        return item
                    })
                )
                
            })
            .then( async result => {
                if(result.length === 0) return
                
                console.log("items removed", result)

                let new_result = []

                for (let i = 0; i < result.length; i++) {
                    let added_item = await addItem(result[i].wc_cart_item_id, result[i].new_quantity)
                    new_result.push(added_item)
                }

                // return await Promise.all(
                //     result.map( async item => {
                //         await addItem(item.wc_cart_item_id, item.new_quantity)
                //         return `${item.wc_cart_item_id} added`
                //     })
                // )
                return new_result
            })
            .then(result => {
                console.log("result updated", result)
                // if(result.length === wcCart.items.length){
                    setTimeout(() => {
                        window.location.href = TEST_URL
                    }, 1000);
                // }
            })
            
        } else {
            window.location.href = TEST_URL
        }

    } else {
        localStorage.clear()
    }


}

export async function getCart(){

    let url = `${MAIN_DOMAIN}/wp-json/cocart/v2/cart`

    const response = await axios.get(url)
    const result = await response.data

    console.log('get cart', result)

    return result

}

export async function removeWcProduct(productId){

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()

    const wcCart = await getCart()

    // console.log("productId to remove", productId)

    if(wcCart !== undefined && wcCart !== null && wcCart.items.length > 0){

        let default_id = productId
        if(LANG !== "en"){
            default_id = ids_langs.find( variation => variation.includes(productId))[0]
        }

        const findProductToRemove = wcCart.items.find(item => `${item.id}` == `${default_id}`)
        // console.log("findProductToRemove", findProductToRemove)

        if(findProductToRemove !== undefined && findProductToRemove !== null){

            const response = await axios.delete(
                `${MAIN_DOMAIN}/cart/?remove_item=${findProductToRemove.item_key}&_wpnonce=${localStorage.getItem("wp_nonce")}`,
                {
                    headers: new Headers({
                        "Content-Type": "application/json"
                    })
                }
            )

            const result = await response.data
            // console.log("removed item", result)
            return result

        } 

    }


}